import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.SubscriptionDetailPage || initialState;

export const selectSubscriptionDetailPage = createSelector(
  [selectSlice],
  state => state,
);
